import _implicitStylesheets from "./headerContainer.css";
import _implicitScopedStylesheets from "./headerContainer.scoped.css?scoped=true";
import _appxNotification from "appx/notification";
import _axAlert from "ax/alert";
import _appxEditorHeader from "appx/editorHeader";
import _appxSecurityHeader from "appx/securityHeader";
import _appxHeader from "appx/header";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "notification-container": true
  },
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  "data-testid": "maintenance-banner"
};
const stc3 = {
  key: 3
};
const stc4 = {
  "data-testid": "announcement-banner"
};
const stc5 = {
  key: 8
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, b: api_bind, h: api_element, ncls: api_normalize_class_name} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("appx-notification", _appxNotification, stc0), $cmp.showMaintenanceBanner ? api_element("div", stc1, [api_custom_element("ax-alert", _axAlert, {
    attrs: stc2,
    props: {
      "theme": "info",
      "alertTitle": $cmp.maintenanceBannerLabel,
      "alertMessage": $cmp.labels.maintenanceAlertDescription
    },
    key: 2,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.handleCloseMaintenanceAlert))
    }
  })]) : null, $cmp.showAnnouncementBanner ? api_element("div", stc3, [api_custom_element("ax-alert", _axAlert, {
    attrs: stc4,
    props: {
      "theme": "info",
      "alertTitle": $cmp.labels.announcementAlertTitle,
      "alertMessage": $cmp.labels.announcementAlertDescription
    },
    key: 4,
    on: {
      "close": _m1 || ($ctx._m1 = api_bind($cmp.handleCloseAnnouncementAlert))
    }
  })]) : null, $cmp.useEditorHeader ? api_custom_element("appx-editor-header", _appxEditorHeader, {
    props: {
      "showMaintenanceBanner": $cmp.showMaintenanceBanner
    },
    key: 5
  }) : null, $cmp.useSecurityHeader ? api_custom_element("appx-security-header", _appxSecurityHeader, {
    props: {
      "showMaintenanceBanner": $cmp.showMaintenanceBanner
    },
    key: 6
  }) : null, $cmp.useCommonHeader ? api_element("div", {
    className: api_normalize_class_name($cmp.cssClass),
    key: 7
  }, [api_custom_element("appx-header", _appxHeader, stc5)]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6pd66no2gcb";
tmpl.legacyStylesheetToken = "page-headerContainer_headerContainer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
